import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { Colors, Space, Shadows, TextStyles } from '../../types';

export const Accordion: ComponentStyleConfig = {
  baseStyle: {
    container: {
      borderColor: Colors.BORDER_DEFAULT,
      _first: {
        borderTopColor: Colors.TRANSPARENT,
      },
      _last: {
        borderBottomColor: Colors.TRANSPARENT,
      },
    },
    icon: {
      color: Colors.ICON_BRAND,
      _disabled: {
        color: Colors.TEXT_DISABLED,
      },
    },
    button: {
      transitionProperty: 'common',
      transitionDuration: 'normal',
      '&': {
        apply: `textStyles.${TextStyles.H4}`,
      },
      color: Colors.TEXT_EMPHASIS,
      _focusVisible: {
        boxShadow: Shadows.NONE,
        outline: '2px solid',
        outlineColor: Colors.BORDER_FOCUS,
        outlineOffset: '-1px',
      },
      _hover: {
        bg: Colors.SURFACE_TERTIARY_HOVER,
      },
      _active: {
        bg: Colors.SURFACE_TERTIARY_ACTIVE,
      },
      _expanded: {
        bg: Colors.SURFACE_TERTIARY,
      },
      _disabled: {
        color: Colors.TEXT_DISABLED,
        opacity: 1,
        cursor: 'not-allowed',
      },
      px: Space.XS,
      py: Space.XS,
    },
    panel: {
      pt: Space['2XS'],
      px: Space.SM,
      pb: Space.SM,
      apply: `textStyles.${TextStyles.P2}`,
    },
  },
  variants: {},
  sizes: {},
  parts: [],
};
